import React, { Component } from 'react';
import moment from 'moment-timezone';
import {
  Router, Route, Switch, Redirect,
} from 'react-router-dom';
import { history } from './utils/history';

import AuthFinish from './components/AuthFinish';
import Company from './components/Company';
import ViewSelecting from './components/ViewSelecting';

import styles from './App.module.css';
import '@anna/anna-ws-ui/dist/styles.css';

moment.tz.setDefault('Europe/London');

class App extends Component {
  render() {
    return (
      <div className={styles.AppContainer}>
        <Router history={history}>
          <Switch>
            <Route
              exact
              path="/"
              component={ViewSelecting}
            />
            <Route
              exact
              path="/auth/finish"
              component={AuthFinish}
            />
            <Route
              path="/company"
              component={
                        ({ match }) => (
                          <Company
                            match={match}
                          />
                        )
                      }
            />
            <Redirect to={{ pathname: '/' }} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
